import { render, staticRenderFns } from "./HomeDonationLinks.vue?vue&type=template&id=473764eb"
import script from "./HomeDonationLinks.vue?vue&type=script&lang=js"
export * from "./HomeDonationLinks.vue?vue&type=script&lang=js"
import style0 from "./HomeDonationLinks.vue?vue&type=style&index=0&id=473764eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports